import type { EventStatus } from "@/types";
import { getStatusMeta } from "@/utils/format";

interface StatusBadgeProps {
  status: EventStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const meta = getStatusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-label tracking-wide whitespace-nowrap ${meta.className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot} ${status === "live" ? "animate-pulse-soft" : ""}`} />
      {meta.label}
    </span>
  );
}